import * as Imgs from 'assets/images';
import { useMemo } from 'react';
import { checkPixel } from 'utils';
import styled from 'styled-components';

export function Img({ src, alt, ratio, className, ...props }) {
  const tempSrc = useMemo(() => {
    const img = Imgs[src];
    if (img) {
      return img;
    } else {
      return src || Imgs['transparent'];
    }
  }, [src]);

  return <Image src={tempSrc} alt={alt} loading="lazy" {...props} className={className} />;
}

const Image = styled.img`
  ${({ onClick }) => onClick && `cursor:pointer`};
  ${({ hide }) => hide && `display:none`};
  width: 100%;
  ${({ $objectFit }) => $objectFit ?  `object-fit:${$objectFit}` : 'object-fit: contain'};
  ${({ $width }) => $width && `width:${checkPixel($width)}`};
  ${({ $height }) => $height && `height:${checkPixel($height)}`};
  ${({ $padding }) => $padding && `padding:${$padding}`};
`;
